import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../../Config';
import { DesignationApi } from '../../../../../Redux/action/MasterAction';
import DrawbackDetails from './SubTabs/DrawbackDetails';
import DutyDetails from './SubTabs/DutyDetails';
import DepbDetails from './SubTabs/DepbDetails';
import Requirment from './SubTabs/Requirement';
import Manufacturer from './SubTabs/Manufacturer';
import Declaration from './SubTabs/Declaration';

const AddExportProduct = () => {
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    const BillOpt = [
        { value: 'aizobel', label: 'Aizobel / INAZ' },
        { value: 'bagdogra', label: 'Bagdogra / INBD' },
        { value: 'akola', label: 'Akola / INAL' },
        { value: 'amritsar', label: 'Amritsar / INAR' }
    ]
    // const { name } = useParams();
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,

    } = useSelector(state => state?.MasterReducer);
    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);
    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    // const columns = [
    //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    //     { title: "Date", dataIndex: "date", key: "date" },
    //     { title: "Name", dataIndex: "name", key: "name" },
    //     { title: "Email", dataIndex: "email", key: "email" },
    //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    //     { title: "Origin", dataIndex: "origin", key: "origin" },
    //     { title: "Destination", dataIndex: "destination", key: "destination" },
    //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    //     { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Name", dataIndex: "Name", key: "Name" },
        { title: "Code", dataIndex: "Code", key: "Code" },
        { title: "Prefix", dataIndex: "Prefix", key: "Prefix" },
        { title: "CheckDigit", dataIndex: "CheckDigit", key: "CheckDigit" },
        { title: "Account No", dataIndex: "AccountNo", key: "AccountNo" },
        { title: "Home Page URL", dataIndex: "HomePageURL", key: "HomePageURL" },
        { title: "Tracking URL", dataIndex: "TrackingURL", key: "TrackingURL" },
        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "Commission", // Ensure date formatting as neede
        Code: "ChargeCategory",
        Prefix: "Applicable",
        CheckDigit: "Charge",
        AccountNo: "AE",
        HomePageURL: "xyz",
        TrackingURL: "xyz",
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>

                {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    },
    {
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "Commission", // Ensure date formatting as neede
        Code: "ChargeCategory",
        Prefix: "Applicable",
        CheckDigit: "Charge",
        AccountNo: "AE",
        HomePageURL: "xyz",
        TrackingURL: "xyz",
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-danger   `}>Inactive</span>

                {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    }]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    {/* <div className="row">
                        <div className="col-md-12">
                           
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Organization List<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div> */}
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="  mb-3">
                                <div className="d-flex align-items-start flex-wrap row">


                                    <div className='col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>

                                            HS Code
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">
                                            {/* <span className="form-icon">
            <i className="ti ti-search" />
        </span> */}
                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Origin District
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Exporter
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            PMV Rate
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-1">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            <label className='form-label mb-0'>
                                                %
                                            </label>
                                        </div>
                                    </div>

                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Origin State
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            IGST Rate
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-1">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            <label className='form-label mb-0'>
                                                %
                                            </label>
                                        </div>
                                    </div>

                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            PTA/FTA info
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Origin District
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Material Code
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Comp. Cess Rate
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-1">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            <label className='form-label mb-0'>
                                                %
                                            </label>
                                        </div>
                                    </div>

                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            Comp. Cess Rate
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-1">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                // placeholder="Search Alias"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            <label className='form-label mb-0'>
                                                %
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="" className='form-label  mb-2'>
                                            {/* Comp. Cess Rate */}
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-3">
                                            <label htmlFor="" className='form-label mb-0'>
                                                Single Window
                                            </label>
                                            <input type="checkbox" className="form-check-input me-2" id="exampleCheck1" />
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="" className='form-label  mb-2'>
                                            {/* Comp. Cess Rate */}
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 d-flex justify-content-start align-items-center gap-3">
                                            <label htmlFor="" className='form-label mb-0'>
                                                Reward Item
                                            </label>
                                            <input type="checkbox" className="form-check-input me-2" id="exampleCheck1" />
                                        </div>
                                    </div>
                                    <div className=' col-6'>
                                        <label htmlFor="" className='form-label  mb-2'>
                                            STR Code
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2 ">
                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <label htmlFor="" className='form-label mb-0'>
                                            Description
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-2">
                                            {/* <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span> */}
                                            <textarea
                                                type="text"
                                                rows="2"
                                                className="form-control "
                                                // placeholder="Search Name"
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row-gap-2">
                                <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link active" id="Basic-tab" data-bs-toggle="pill" data-bs-target="#Basic" type="button" role="tab" aria-controls="Basic" aria-selected="true">Drawback Details
                                        </button>
                                    </li>
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="Excise-tab" data-bs-toggle="pill" data-bs-target="#Excise" type="button" role="tab" aria-controls="Account Info" aria-selected="false">Duty Details
                                        </button>
                                    </li>
                                    {/* <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="Billing-tab" data-bs-toggle="pill" data-bs-target="#Billing" type="button" role="tab" aria-controls="Billing" aria-selected="false">Billing</button>
                                    </li> */}
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="GST-tab" data-bs-toggle="pill" data-bs-target="#GST" type="button" role="tab" aria-controls="GST" aria-selected="false">DEPB Details
                                        </button>
                                    </li>
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="Other-tab" data-bs-toggle="pill" data-bs-target="#Other" type="button" role="tab" aria-controls="Other" aria-selected="false">Requirements
                                        </button>
                                    </li>
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="Generic-tab" data-bs-toggle="pill" data-bs-target="#Generic" type="button" role="tab" aria-controls="Generic" aria-selected="false">Manufacturer
                                        </button>
                                    </li>
                                    <li className="nav-item me-1" role="presentation">
                                        <button className="nav-link" id="ITCDetails-tab" data-bs-toggle="pill" data-bs-target="#ITCDetails" type="button" role="tab" aria-controls="ITCDetails" aria-selected="false">Declarations
                                        </button>
                                    </li>


                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="Basic" role="tabpanel" aria-labelledby="Basic-tab">
                                        <DrawbackDetails /> {/* <BasicCustomDuty /> */}
                                    </div>
                                    <div className="tab-pane fade" id="Excise" role="tabpanel" aria-labelledby="Excise-tab">
                                        <DutyDetails />  {/* <CentralExciseDuty />   */}
                                    </div>
                                    <div className="tab-pane fade" id="GST" role="tabpanel" aria-labelledby="GST-tab">
                                        <DepbDetails /> {/* <Gst />  */}
                                    </div>
                                    <div className="tab-pane fade" id="Other" role="tabpanel" aria-labelledby="Other-tab">
                                        <Requirment /> {/* <OthDuties />  */}
                                    </div>
                                    <div className="tab-pane fade" id="Generic" role="tabpanel" aria-labelledby="Generic-tab">
                                        <Manufacturer/>  {/* <GenericDescription />  */}
                                    </div>

                                    <div className="tab-pane fade" id="ITCDetails" role="tabpanel" aria-labelledby="ITCDetails-tab">
                                        <Declaration/>  {/* <ItcDetails />  */}
                                    </div>


                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default AddExportProduct